import { useState } from "react";
import AccordionItem from "./AccordionItem";

const Accordion = ({ items }) => {
  const [openItem, setOpenItem] = useState(0);
  const handleToggle = (index) => {
    if (openItem === index) {
      setOpenItem(-1);
    } else {
      setOpenItem(index);
    }
  };
  return (
    <>
      {items.map((item, index) => (
        <AccordionItem item={item} index={index} handleToggle={handleToggle} openItem={openItem}/>
      ))}
    </>
  );
};
export default Accordion;

